function parseToRem(pixel, base) {
    if (base === void 0) { base = 100; }
    if (+pixel === 0)
        return 0;
    if (!pixel)
        return 'inherit';
    var px = pixel;
    if (typeof px === 'string' && px.indexOf('px') > -1) {
        px = px.replace(/\D/g, '');
    }
    return Number(px) / base + "rem";
}
export default parseToRem;
//# sourceMappingURL=parseToRem.js.map